import { render, staticRenderFns } from "./MyProject.vue?vue&type=template&id=661a2b9e&scoped=true&"
import script from "./MyProject.vue?vue&type=script&lang=js&"
export * from "./MyProject.vue?vue&type=script&lang=js&"
import style0 from "./MyProject.vue?vue&type=style&index=0&id=661a2b9e&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661a2b9e",
  null
  
)

export default component.exports